/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, June 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import SpecifiedAttachmentsPanel from '../../components/SpecifiedAttachmentsPanel/SpecifiedAttachmentsPanel';
import RodoContent from '../../components/RodoContent/RodoContent';
import { connect } from 'react-redux';
import { runService, saveValidators } from '../../actions/eservices';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import agentConfig from './agent';
import loadingData from './loading';
import { InitialAttachmentsDict, bodyStyle, redirectToSummary } from './constants';
import { trackEvent } from '../../lib/utils';
import ButtonsPanel from './utils/ButtonsPanel';
import waiting from '../paymentStatus/waiting-wheel-300x300.gif';
import { showDraftsCondition, saveDraft, areEqual, getDraft, getDraftDataFromState } from '../../components/DraftManagement/draftManager';


import v from './validators';


const AddressFormDict = {
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
};

const infoDict = {
  wlasciciel: {
    label: 'Właściciel nieruchomości',
    editable: true,
    type: "textarea",
    rows: 3,
  },
  wspolwlasciciel: {
    label: 'Współwłaściciel nieruchomości',
    editable: true,
    type: "textarea",
    rows: 3,
  },
};


const infoDict2 = {
  gatunek: {
    label: 'Gatunek drzewa',
    editable: true,
  },
  obwod: {
    label: 'Obwód pnia drzewa na wysokości 5 cm',
    editable: true,
  },
  count: {
    label: 'Liczba sztuk do wycięcia',
    editable: true,
  },
};

const stateToDraft = [
  "DecisionData",
  "info",
  "selectedParcels",
  "selectedRoads",
  "attachments",
];


class ZgloszenieUsunieciaDrzew extends React.Component {
  state = {
    DecisionData: {
      AddressCity: null,
      AddressStreet: null,
      wlasciciel: null,
      wspolwlasciciel: null,
      gatunek: null,
      obwod: null,
      count: null,
    },
    info: {
      numerKw: null,
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachmentsDict: InitialAttachmentsDict[this.props.serviceInfo.eservice.shortName] || {},
    attachments: null,
    draftAttachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
    showDrafts: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    AddressCity: [v.NotNull],
    AddressStreet: [],
    wlasciciel: [v.NotNull],
    wspolwlasciciel: [],
    gatunek: [],
    obwod: [],
    count: [],
    agentName: [],
    agentAddress: [],
    agentPostOffice: [],
    agentPostalCode: [],
    agentPhoneNumber: [],
  };

  async componentDidMount() {
    const showDrafts = showDraftsCondition(this.props.prefix);
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
          showDrafts: showDrafts,
        }, () => this.updateValidators());
      });

    if (showDrafts) {
      const draftData = await getDraft(this.props.prefix, this.props.serviceInfo.eservice.shortName);

      if (draftData) {
        this.setState({ ...draftData, draftAttachments: draftData.attachments, isMounted: true }, () => {
          window.dispatchEvent(
            new CustomEvent("draft:loaded")
          );
        });
      } else {
        this.setState({ isMounted: true });
      }
    } else {
      this.setState({
        isMounted: true
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showDrafts) {
      if (!this.state.isMounted) return;

      if (!prevState.isMounted && this.state.isMounted) return;

      const prevDraft = getDraftDataFromState(prevState, stateToDraft);
      const currentDraft = getDraftDataFromState(this.state, stateToDraft);

      if (this.props.serviceInfo.user && !areEqual(prevDraft, currentDraft)) {
        saveDraft(
          currentDraft,
          this.props.prefix,
          this.props.serviceInfo.eservice.shortName
        );
      }
    }
  }

  handleManualDraftSave = () => {
    const draft = getDraftDataFromState(this.state, stateToDraft);

    saveDraft(
      draft,
      this.props.prefix,
      this.props.serviceInfo.eservice.shortName,
      { debounce: false } // wymuszony zapis
    );
  };

  updateValidators = () => {
    if (this.props.prefix === 'gmina_komarow_osada') {
      this.validators.gatunek = [v.NotNull];
      this.validators.obwod = [v.NotNull];
      this.validators.count = [v.NotNull, v.isStrictInteger];
      this.validators.wlasciciel = [];
    } else {
      this.validators.gatunek = [];
      this.validators.obwod = [];
      this.validators.count = []
      this.validators.wlasciciel = [v.NotNull];
    }
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['DecisionData', 'info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
    if (name === 'agentAdd') {
      this.onChangeAgent(e.value);
    }
  }

  onChangeAgent = (value) => {
    if (value === 'TAK') {
      this.validators.agentName = [v.NotNull];
      this.validators.agentAddress = [v.NotNull];
      this.validators.agentPostOffice = [v.NotNull];
      this.validators.agentPostalCode = [v.NotNull];
      this.validators.agentPhoneNumber = [v.NotNull, v.isNumber];
      this.validators.agentMotionAddress = [v.NotNull];
    } else {
      this.validators.agentName = [];
      this.validators.agentAddress = [];
      this.validators.agentPostOffice = [];
      this.validators.agentPostalCode = [];
      this.validators.agentPhoneNumber = [];
      this.validators.agentMotionAddress = [];
    }
  }

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      return this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
    }

    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      return this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      return this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
    }

    if (this.state.DecisionData.wspolwlasciciel && !this.state.attachments.some(obj => obj.type === 'zgody')) {
        return this.setState({
          errorText: 'W przypadku uzupełnienia danych współwłaściciela należy dodać załącznik: zgoda wszystkich współwłaścicieli na usunięcie drzew',
          errorTitle: 'Brak załącznika.',
          showError: true,
          loading: false,
        });
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          DecisionData: { ...this.state.DecisionData },
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,

        })
        .then(resp => {
          this.setState({
            loading: false }, () => {
              trackEvent({
                category: 'application',
                action: 'click',
                name: this.props.serviceInfo.eservice.title,
              });
              redirectToSummary(resp.jobId);
            }
          );
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);

    if (!this.state.isMounted) {
      return (
        <GrayPanel
          title="Trwa ładowanie zawartości..."
          bodyStyle={bodyStyle}
        >
          <img alt="Loader" src={waiting} />
        </GrayPanel>
      );
    }

    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'1. Adres'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={AddressFormDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
            treeSelection
            showPdfExport
          />
        </DecisionContainer>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ fontWeight: 'bold' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <DecisionContainer
          title={'2. Informacje dodatkowe'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={this.props.prefix === 'gmina_komarow_osada' ? infoDict2 : infoDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        />

        <GrayPanel title={'Informacja dodatkowe'}>
          <div className="row">
            <div className="col-sm-12">
              <p><b>Na usunięcie drzew, które rosną na nieruchomościach stanowiących własność
                 osób fizycznych  i są usuwane na cele niezwiązane z prowadzeniem działalności
                 gospodarczej
                  - właściciel nieruchomości jest zobowiązany dokonać zgłoszenia zamiaru usunięcia drzewa, jeżeli obwód pnia drzewa mierzonego na wysokości 5 cm przekracza:</b></p>
              <p>1. 80 cm - w przypadku topoli, wierzb, klonu jesionolistnego oraz klonu srebrzystego; </p>
              <p>2. 65 cm - w przypadku kasztanowca zwyczajnego, robinii akacjowej oraz platanu klonolistnego; </p>
              <p>3. 50 cm - w przypadku pozostałych gatunków drzew. </p>
            </div>
          </div>
        </GrayPanel>

        <RodoContent prefix={this.props.prefix} />

        <SpecifiedAttachmentsPanel
          attachmentsDict={this.state.attachmentsDict}
          onChangeAttachments={this.onChangeAttachments}
          showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}
          draftAttachments={this.state.draftAttachments}
        />
        
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <ButtonsPanel
          prefix={this.props.prefix}
          shortName={this.props.serviceInfo.eservice.shortName}
          serviceTitle={this.props.serviceInfo.eservice.title}
          showDrafts={this.state.showDrafts}
          onDraftSave={this.handleManualDraftSave}
          onSave={() => this.setState({ loading: true }, () => this.startService())}
          onCancel={history.goBack}
        />

      </div>
    );
  }
}

ZgloszenieUsunieciaDrzew.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
  saveValidators,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ZgloszenieUsunieciaDrzew),
);



// WEBPACK FOOTER //
// src/routes/eservices/ZgloszenieUsunieciaDrzew.js